<template>
  <v-container>
    <v-layout wrap justify-center>
      <v-card class="ma-0 mt-0">
        <v-form id="package">
          <div class="ma-2">연동장비 정보 </div>
            
          <v-select dense outlined class="ma-1" style="height: 45px; width: auto;" v-show="false"
            id="company" 
            ref="company" 
            label="경영체✽" 
            v-model="company"
            :items="companyItems"
            :menu-props="{ top: false, offsetY: true }"
            :loading="loadingMac" 
            no-data-text="자료(권한)이 없습니다."
            item-text="company_name"
            return-object
            @change="changeCompany()"
            @focus="comboCompanies()"
            clearable
          />

          <v-select dense outlined  class="ma-1" style="height: 45px; width: auto;" 
            id="farm" 
            ref="farm" 
            label="농장/사업장✽" 
            v-model="farm"
            :items="farmItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="farm_name"
            return-object
            @change="changeFarm()"
            @focus="comboFarms()"
            clearable
          />
          <v-select dense outlined  class="ma-1" style="height: 45px; width: auto;"
            id="building" 
            ref="building" 
            label="축사/건물/구역✽" 
            v-model="building"
            :items="buildingItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="building_name"
            return-object
            @change="changeBuilding()"
            @focus="comboBuildings()"
            clearable
          />
          <v-select dense outlined  class="ma-1" style="height: 45px; "
            id="room" 
            ref="room" 
            label="돈방/위치✽" 
            v-model="room"
            :items="roomItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="room_name"
            return-object
            @change="changeRoom()"
            @focus="comboRooms()"
            clearable
          />

          <v-layout>
            <v-select dense outlined class="ma-1" style="height: 40px; width: 180px"
              id="device_type" 
              ref="device_type" 
              label="장비유형✽" 
              v-model="device_type"
              :items="device_typeItems"
              :menu-props="{ top: false, offsetY: true }"
              placeholder="연동장비 종류를 선택하세요" 
              item-text="name"
              @change="changeType(device_type)"
              return-object
            />
            <v-select dense outlined class="ma-1" style="height: 40px; width: 180px"
              id="device_code" 
              ref="device_code" 
              label="장비코드✽" 
              v-model="device_code"
              :items="device_codeItems"
              :menu-props="{ top: false, offsetY: true }"
              placeholder="연동장비 코드를 선택하세요" 
              item-text="description" 
              @focus="comboCode(true)"
              @change="changeCode(device_code)"
              clearable
              return-object
            />
          </v-layout>
        
          <v-autocomplete dense outlined class="ma-1" style="height: 45px;"
            ref="model"
            v-model="model"
            :items="modelItems"
            label="모델명✽"
            item-text="code"  
            item-value="code"
            return-object    
            @focus="comboModel(true)"
            @blur="onModelBlur"
            :search-input.sync="search_model"
            clearable
            required
          ></v-autocomplete>
          <v-layout>
            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="rut_number" 
              ref="rut_number" 
              label="장비 일련번호" 
              v-model="rut_number"
              placeholder="장비 일련번호를 '정확히' 등록하세요"
              maxlength="30"
              clearable
            />

            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="fc_number" 
              ref="fc_number" 
              type="number"
              label="컨트롤러 번호" 
              v-model="fc_number"
              placeholder="연결된 fc 번호를 등록하세요"
              maxlength="20"
              clearable
            />
          </v-layout>


          <v-layout style="margin-top:-5px;">
            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="device_number" 
              ref="device_number" 
              label="축평원 장비 일련번호" 
              v-model="device_number"
              placeholder="축평원 장비 일련번호를 '정확히' 등록하세요"
              maxlength="30"
              clearable
            />

            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="sn_number" 
              ref="sn_number" 
              type="number"
              label="장비 고유번호✽" 
              v-model="sn_number"
              placeholder="장비 고유번호를 '정확히' 등록하세요"
              maxlength="20"
              clearable
            />
          </v-layout>

          <v-text-field dense outlined class="ma-1" style="height: 45px; width: auto;"
            id="device_name" 
            ref="device_name" 
            label="장비 식별명✽" 
            v-model="device_name"
            placeholder="사용자들이 알 수 있게 식별명을 입력하세요."
            maxlength="20"
            clearable
          />

          <v-layout>
          <v-menu
            v-model="menuSensorSetdate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="ma-1" 
                id="setdate" 
                ref="setdate" 
                v-model="setdate"
                label="설치일✽"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="setdate"
              @input="menuSensorSetdate = false"
            ></v-date-picker>
          </v-menu>
          <!-- <v-menu
            v-model="menuSensorDeldate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="shrink mr-1" style="width: 180px"
                id="deldate" 
                ref="deldate" 
                v-model="deldate"
                label="중지일"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="deldate"
              @input="menuSensorDeldate = false"
            ></v-date-picker>
          </v-menu> -->
          </v-layout>

          <v-textarea outlined dense rows="2" name="input-7-4" style="height: auto; margin: -15px 3px 0px 5px"
            label="비고"
            id="history" 
            ref="history" 
            v-model="history"
            value=""
            persistent-hint :hint="hint"
          ></v-textarea>
          <v-card-actions class="d-block" >
            <v-row justify= "center" >
              <v-spacer ></v-spacer>
              <v-btn rounded class="normal-btn mr-2" style="height: 30px; width: 20px;  margin-bottom: 15px"
                :loading="loadingSave" 
                id="save" 
                ref="save"
                type="submit" 
                @click.prevent="save()">
                저장
              </v-btn>
              <v-btn rounded class="new-btn mr-2" style="height: 30px; width: 20px;  margin-bottom: 15px" 
                id="clear" 
                ref="clear" 
                @click="newRegister()">
                새로
              </v-btn>
              <v-spacer ></v-spacer>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>

      <v-card class="ma-0 ml-1 mt-0" width="65%">
        <v-radio-group v-model="filterStatus" row class="radio-group">
          <v-radio 
            color="#004297"
            value="all"
            label="전체"
          ></v-radio>
          <v-radio 
            color="#3a4f4f"
            value="active"
            label="가동"
          ></v-radio>
          <v-radio 
            value="del"
            label="중지"
            color="#88191A"
          ></v-radio>
        </v-radio-group>
        <v-data-table dense nowrap height="550px" class="elevation-3  v-data-table" style=" margin-left: 1px; margin-right: 0px "
          id="items" 
          ref="items"
          :loading="loadingList" 
          :headers="headers"
          :items="displayItems"
          :items-per-page= "50000"
          no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer
          @click:row="infoDetail"
          sort-by="room"
          group-by="room.farm.name"
          show-group-by
          item-key="id"
          :item-class="itemRowBackground"
          single-select
          :search="search"
        >
          <template v-slot:group.header="{items, isOpen, toggle}">
            <th colspan="9">
              <v-icon @click="toggle"
                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
              </v-icon>
              {{ items[0].room.farm.name }}
            </th>
          </template>
        </v-data-table>

        <v-card-title>
          <v-text-field dense style="width:250px" class="shrink"
            clearable
            v-model="search"
            append-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-card-actions class="justify-center">
          <v-btn rounded-pill class="elevation-5 ma-3 rounded-pill normal-btn" style="height: 35px;"
            id="refreshList" 
            ref="refreshList" 
            @click="refreshList()">
            <v-icon left dark>mdi-refresh</v-icon>
            목록고침
          </v-btn>
        </v-card-actions>
      </v-card>
        


    </v-layout>
  </v-container>
</template>

<script>
import Apis from '@/api/apis'
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

var save_device_id = "";

export default {
  name: 'RegisterPackage',
  data: () => ({
    search:'',
  
    items: [],
    headers: [
      { text: '농장/사업장', align: 'left', value: 'room.farm.name', sortable: false, groupable: false, width: "110px", class: 'green darken-4 white--text',divider: false  },
      { text: '돈방/구역', align: 'left', value: 'room.room.name', sortable: false, groupable: false, width: "100px", class: 'green darken-4 white--text',divider: false  },
      { text: '식별명', align: 'left', value: 'device_name', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      // { text: '장비유형', align: 'left', value: 'division.description', sortable: false, groupable: false, width: "140px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비명', align: 'left', value: 'type.description', sortable: false, groupable: false, width: "150px", class: 'green darken-4 white--text',divider: false  },
      { text: '모델명', align: 'left', value: 'model', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비일련번호', align: 'left', value: 'rsvr1', sortable: false, groupable: false, width: "160px", class: 'green darken-4 white--text',divider: false  },
      { text: '축평원장비일련번호', align: 'left', value: 'sn', sortable: false, groupable: false, width: "160px", class: 'green darken-4 white--text',divider: false  },
      
      { text: '장비번호', align: 'left', value: 'local_sn', sortable: false, groupable: false, width: "80px", class: 'green darken-4 white--text',divider: false  },
      
      { text: '등록일', align: 'left', value: 'setdate', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      // { text: '중지일', align: 'left', value: 'sn', sortable: false, groupable: false, width: "100px", class: 'green darken-4 white--text',divider: false  },

    ],


    company : {},
    companyItems : [],
    farm : {},
    farmItems : [],
    building : {},
    buildingItems : [],
    room : {},
    roomItems : [],

    device_type: {},
    device_typeItems : Common.comboBaseCode("EX"),
    
    Devision_code:"",

    device_code: {},
    device_codeItems : [],

    model: "",
    search_model:"",
    modelItems : [],

    fc_number:"",
    rut_number:"",

    device_number:"",
    sn_number:"",

    device_name: "",

    smart_mac: "",
    slave_id: "",
    setdate: "",
    // deldate: "",
    history: "",
    hint: "",

    loadingMac: false,
    loadingSave: false,
    loadingList: false,

    device_dialog : false,


    msgflag: true,

    menuSensorSetdate:false,
    // menuSensorDeldate:false,


    filterStatus: 'all',

  }),
  computed: {
    displayItems() {
      if (this.filterStatus === 'all') {
        return this.items;
      } else if (this.filterStatus === 'active') {
        return this.items.filter(item => !item.deldate || item.deldate === '');
      } else if (this.filterStatus === 'del') {
        return this.items.filter(item => item.deldate && item.deldate !== '');
      }
      return this.items;
    }
  },
  created() {
    this.comboCompanies();
    this.comboFarms();
    this.comboBuildings();
    this.comboRooms();

    // this.comboCode();
    // this.comboModel();

    this.$store.commit("resMessage","");

    this.refreshList();
    sessionStorage.setItem("deviceTab",5)

  },

  methods: {
    newRegister() {   
      this.clearData();

      this.$store.commit("resMessage","새로운 디바이스를 입력할 준비가 되었습니다.");
      this.$refs.farm.focus();
    },
    clearData() {
      this.device_id = "";

      this.company = {};
      
      this.device_type = {};
      this.device_code = {};
      this.model = "";

      this.rut_number = "";
      this.fc_number = "";
      this.device_number = ""
      this.sn_number = ""
      
      this.device_name = "";

      this.farm = {};
      this.building = {};
      this.room = {};

      this.setdate = "";
      // this.deldate = "";
      this.history = "";
      this.hint = "";
    }, 
    checkData() {
      // console.log("model:", this.model, typeof this.model);
      if (!this.farm.farm_cd) {
        this.$refs.farm.focus();
        return "농장/사업장을 선택하세요";
      }
      if (!this.building.building_cd) {
        this.$refs.building.focus();
        return "축사/건물/구역을 선택하세요";
      }
      if (!this.room.room_cd) {
        this.$refs.room.focus();
        return "돈방/위치를 선택하세요";
      }

      if (!this.device_type.code) {
        this.$refs.device_type.focus();
        return "장비유형을 선택하세요";
      }

      if (!this.device_code.basecode) {
        this.$refs.device_code.focus();
        return "장비코드 선택하세요";
      }

      if (!this.model.trim()) {
        this.$refs.model.focus();
        return "디바이스 모델명을 선택 또는 입력하세요";
      }
      if (!this.sn_number.trim()) {
        this.$refs.sn_number.focus();
        return "장비 고유번호를 정확히 입력하세요";
      }
      if (!this.device_name.trim()) {
        this.$refs.device_name.focus();
        return "장비 식별명을 입력하세요";
      }

      if (!this.setdate) {
        this.$refs.setdate.focus();
        return "설치일을 선택입력하세요";
      }
      return "";
    },
    save() {
      // console.log("model", this.model);
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }

      this.loadingSave = true;

      save_device_id = this.device_id;
      // console.log(save_device_id)

      if (this.device_id) {
        //업데이트
        Apis.updatePackageDevice({
          "id" : this.device_id,
          "farm" : this.farm.farm_cd,
          "room" : this.room.room_cd,
          "division" : this.device_type.code,
          "type" : this.device_code.basecode,
          "model" : this.model,
          "sn" : this.device_number || null,
          "local_sn" : this.sn_number,
          "device_name" : this.device_name,
          "history" : this.history.trim(),
          "rsvr1" : this.rut_number || null,
          "rsvr2" : "",
          "rsvr3" : "",
          "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
          "no2" : null,
          "no3" : null,
          // "etc3" : this.history.trim(),
          "setdate" : this.setdate,
          },(res) => {  
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.loadingSave = false;
              this.msgFlag = false;
              
              save_device_id = this.device_id;
              this.clearData();

              this.refreshList();
            } else {
              this.loadingSave = false;
              alert(res.message);

                // 디버깅용
              console.log("저장할 데이터:", {
                "id" : this.device_id,
                "farm" : this.farm.farm_cd,
                "room" : this.room.room_cd,
                "division" : this.device_type.code,
                "type" : this.device_code.basecode,
                "model" : this.model,
                "sn" : this.device_number || null,
                "local_sn" : this.sn_number,
                "device_name" : this.device_name,
                "history" : this.history.trim(),
                "rsvr1" : this.rut_number || null,
                "rsvr2" : "",
                "rsvr3" : "",
                "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
                "no2" : null,
                "no3" : null,
                // "etc3" : this.history.trim(),
                "setdate" : this.setdate,
              });

            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류",err)
              alert(err);
          }
        )
      } else {
        //등록
        Apis.insertPackageDevice({
          "farm" : this.farm.farm_cd,
          "room" : this.room.room_cd,
          "division" : this.device_type.code,
          "type" : this.device_code.basecode,
          "model" : this.model,
          "sn" : this.device_number || null,
          "local_sn" : this.sn_number, 
          "device_name" : this.device_name,
          "history" : this.history.trim(),
          "rsvr1" : this.rut_number || null,
          "rsvr2" : "",
          "rsvr3" : "",
          "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
          "no2" : null,
          "no3" : null,
          // "etc3" : this.history.trim(),
          "setdate" : this.setdate,
          },(res) => {  
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.msgFlag = false;
              this.loadingSave = false;
              this.msgFlag = false;
              // console.log("저장");
              this.refreshList();
              save_device_id = this.device_id;
              this.clearData();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류",err)
              alert(err);
          }
        )
      }
    },
    async infoDetail(value,row) {
      row.select(true)
      this.$store.commit("resMessage","");

      this.clearData();

      Apis.infoPackageDevice({
        id: value.id,
        },async (res) => {  
          if (res.result) {
            // console.log(res.data)
 
            this.device_id = res.data.id;
            this.company = {company_cd: res.data.room.company.code, company_name: res.data.room.company.name};
            this.farm = {farm_cd: res.data.room.farm.code, farm_name: res.data.room.farm.name};
            this.building = {building_cd: res.data.room.building.code, building_name: res.data.room.building.name};
            this.room = {room_cd: res.data.room.room.code, room_name: res.data.room.room.name};

            // 2. device_type 설정
            this.device_type = {code: res.data.division.basecode, name: res.data.division.description};
            this.Devision_code = res.data.division.basecode.slice(-2);

            // 3. device_code, model 정보 그냥 바로 설정
            this.device_code = {basecode: res.data.type.basecode, description: res.data.type.description};
            this.model = res.data.model;

            // console.log(this.model)

            // 4. 나머지 필드 설정
            this.rut_number = res.data.rsvr1;
            this.fc_number = res.data.no1;

            this.device_number = res.data.sn;
            this.sn_number = res.data.local_sn;
            this.device_name = res.data.device_name;
            this.setdate = res.data.setdate;
            this.history = res.data.history; 
            this.hint = res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정";

            this.comboCode();     
            this.comboModel(true); 

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            // alert(err);
        }
      ); 
 
 

      // 인포
    },
    refreshList() {
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.loadingList = true;
      // // console.log("리스트");
  
      //조회
      Apis.listPackageDevices({
        } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.items = res.data;

        if (this.msgFlag) this.$store.commit("resMessage",res.message);

        this.loadingList = false;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listFarms 호출 오류",err);
        this.$router.push("/");
      }) 
    }, 
   comboCompanies() {
      Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.companyItems = res.data;
          } else {
            this.companyItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboCompanies API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeCompany() {   // 하위 콤보 지우기;
      this.farm = {};
      this.building = {};
      this.room = {};
    },
    comboFarms() {
      Apis.comboFarms({
        // company_cd: this.company && this.company.company_cd || "",
        company_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
        if (res.result) {
            this.farmItems = res.data;
          } else {
            this.farmItems = [];
            alert(res.message);  
          } 
          }).catch( (err) => {  // API 오류 처리
          console.log("comboFarms API 호출 오류",err)
          alert(err);
        }
      ) 
    },
    changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      // if (this.farm && this.farm.company_cd) {
        // this.company = {company_cd: this.farm.company_cd, company_name: this.farm.company_name};
        this.building = {};
        this.room = {};
      // }
    },
    comboBuildings() {
      Apis.comboBuildings({
        company_cd:this.company &&  this.company.company_cd || "",
        farm_cd: this.farm && this.farm.farm_cd || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
        if (res.result) {
            this.buildingItems = res.data;
          } else {
            this.buildingItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.building && this.building.company_cd) {
        this.company = {company_cd: this.building.company_cd, company_name: this.building.company_name};
      }
      if (this.building && this.building.farm_cd) {
        this.farm = {farm_cd: this.building.farm_cd, farm_name: this.building.farm_name};
      }
        this.room = {};
    },
    comboRooms() {
      Apis.comboRooms({
        company_cd:this.company &&  this.company.company_cd || "",
        farm_cd: this.farm && this.farm.farm_cd || "",
        building_cd: this.building && this.building.building_cd || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        name_flag: true, 
        },(res) => {  
          if (res.result) {
            this.roomItems = res.data;
          } else {
            this.roomItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboRooms API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeRoom() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.room && this.room.company_cd) {
        this.company = {company_cd: this.room.company_cd, company_name: this.room.company_name};
      }
      if (this.room && this.room.farm_cd) {
        this.farm = {farm_cd: this.room.farm_cd, farm_name: this.room.farm_name};
      }
      if (this.room && this.room.building_cd) {
        this.building = {building_cd: this.room.building_cd, building_name: this.room.building_name};
        // this.device_name = this.room.building_name + " " + this.room.room_name;
      } else{
        this.device_name = "";
      }
    },
    // 장비유형
    changeType(device_type){
      // console.log(device_type)
      this.Devision_code = device_type.code.slice(-2);
      // console.log("장비유형 리스트", this.device_typeItems)
      this.comboCode();
    },
    comboCode(flag){

      if (flag && !this.Devision_code) {
        alert("장비유형을 먼저 선택하세요.");
        this.$refs.device_type.focus();
        return;
      }
      Apis.baseCodeList({
      "division" : this.Devision_code
      },(res) => {  
        if (res.result) {
          this.device_codeItems = res.data;
        } else {
          this.device_codeItems = [];
          alert(res.message);  
        } 
      }).catch( (err) => {  // API 오류 처리
          console.log("baseCodeList API 호출 오류",err)
          alert(err);
      }) 
    },
    changeCode(device_code){
      // console.log("장비코드 리스트", this.device_codeItems)
      this.device_code = device_code;
      this.model="";
    },  
    comboModel(flag){
      if (flag && !this.device_code.basecode) {
        alert("장비코드를 먼저 선택하세요.");
        this.$refs.device_code.focus();
        return;
      }
      Apis.listPackageDeviceModels({
      "type" : this.device_code.basecode
      },(res) => {  
        if (res.result) {
          this.modelItems = res.data;
        } else {
          this.modelItems = [];
          alert(res.message);  
        } 
      }).catch( (err) => {  // API 오류 처리
          console.log("listPackageDeviceModels API 호출 오류",err)
          alert(err);
      }) 
    },
    onModelBlur(){
      // 사용자가 드롭다운에서 안 고르고 직접 입력만 한 경우
      const found = this.modelItems.find(item => item.detail === this.search_model);
      if (!found && this.search_model.trim()) {
        this.model = this.search_model.trim(); // 직접 입력한 텍스트로 저장
      }
    },
    itemRowBackground(item) {
      // console.log("key",item.controller_key,save_controller_id);
      return item.id == save_device_id ? 'selected' : '' ;

    },



  }  // -----------methods 

}
// 01-06
</script>

<style lang="scss" scoped>
.v-data-table::v-deep{
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size:13px;
      height:40px !important;
    }
  }
}
::v-deep .radio-group{
  padding:0 5px !important;
  height:35px !important;
  margin-top:5px;
}
.flex{
  display: flex;
}
.s-bt{
  justify-content: space-between;
}
.normal-btn , .search-btn{
  background-color: #3a4f3f !important;
  color:white;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
}
.search-btn{
  height:40px !important;
  width:50px !important;
  border-radius:20px !important;
}
.new-btn{
  color:#3a4f3f !important;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
  background-color: rgb(248, 248, 248) !important;
}
.dialog-btn{
  color:white !important;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
  background-color: #88191a !important;
}
</style>
